import React from 'react';
import { Container, Typography, Paper, Link } from '@mui/material';
import { styled } from '@mui/system';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(4),
    marginTop: theme.spacing(4),
    borderRadius: theme.spacing(2),
    boxShadow: '0 3px 5px 2px rgba(0, 0, 0, .1)',
}));

function FAQ() {
    return (
        <Container maxWidth="md" style={{ marginTop: '50px' }}>
            <Typography variant="h4" component="h1" align="center" gutterBottom>
                FAQ
            </Typography>
            <Typography variant="h6" component="h2" align="center" gutterBottom>
                Borrowed, Inc. — Frequently Asked Questions (FAQ)
            </Typography>
            <StyledPaper>
                <Typography variant="h6" gutterBottom>
                    1. What is Borrowed?
                </Typography>
                <Typography paragraph>
                    Borrowed is a peer-to-peer rental marketplace that allows users to lend and borrow everyday items—tools, electronics, gear, and more—in exchange for payment. Think of it as a way to monetize things you already own or save money by renting instead of buying.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    2. Who can use Borrowed?
                </Typography>
                <Typography paragraph>
                    You must be at least 18 years old and capable of entering into a binding legal agreement. Borrowed is currently available in the U.S. and Canada.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    3. How do I rent something on Borrowed?
                </Typography>
                <Typography paragraph>
                    Search for items near you, submit a request to the Owner/Lender, and once they approve, you'll be charged the rental fee. Coordinate delivery or pickup through chat.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    4. How do I list an item for rent?
                </Typography>
                <Typography paragraph>
                    Create an account, add a listing with photos and a description, set your price and availability, and publish it. Borrowers will request to book your item.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    5. What does it cost to use Borrowed?
                </Typography>
                <Typography paragraph>
                    <strong>Owner/Lender:</strong> We deduct a 14% fee from your earnings.
                </Typography>
                <Typography paragraph>
                    <strong>Borrowers:</strong> The Borrowed platform is free to use. Pricing for goods is set by and at the discretion of the Owner/Lender.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    6. What if something I rented gets damaged, lost, or stolen?
                </Typography>
                <Typography paragraph>
                    Borrowers are financially responsible for returning items in their original condition. Borrowed may charge the Borrower up to the item's fair market value if damage, loss, or theft occurs.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    7. Is there insurance for my items?
                </Typography>
                <Typography paragraph>
                    Borrowed offers an optional Owner/Lender Protection Policy to eligible users for compensation on qualifying lost, stolen, or damaged items. It is not a replacement for personal insurance. Learn more at&nbsp;
                    <Link href="https://getborrowed.com/Owner/Lender-protection" target="_blank" rel="noopener">
                        [getborrowed.com/Owner/Lender-protection]
                    </Link>
                    &nbsp;(coming soon).
                </Typography>

                <Typography variant="h6" gutterBottom>
                    8. Are off-platform transactions allowed?
                </Typography>
                <Typography paragraph>
                    No. To ensure trust and protection for all users, all rentals/items borrowed and payments must go through the Borrowed platform. Users found engaging in commission avoidance may be fined or banned.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    9. What if I have an issue with another user?
                </Typography>
                <Typography paragraph>
                    We encourage users to resolve issues directly. If that fails, you may request mediation through Borrowed. We may help resolve disputes, but are not a party to any transactions.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    10. How are payments handled?
                </Typography>
                <Typography paragraph>
                    We use Stripe to process all payments securely. Owner/Lenders are paid out 48 hours after a rental ends. Borrowers are charged once a booking is confirmed.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    11. How do reviews work?
                </Typography>
                <Typography paragraph>
                    After a transaction ends, both Owner/Lenders and Borrowers can leave ratings and reviews. These help build community trust. Reviews must be honest and respectful.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    12. Can I delete my account?
                </Typography>
                <Typography paragraph>
                    Yes. You may request account deletion at any time via your settings or by contacting us. You are still responsible for any active rentals or outstanding obligations.
                </Typography>

                <Typography variant="h6" gutterBottom>
                    13. Who do I contact for help?
                </Typography>
                <Typography paragraph>
                    Reach us anytime at&nbsp;
                    <Link href="mailto:info@getborrowed.com">info@getborrowed.com</Link>. We’re here to help!
                </Typography>

                <Typography align="center" paragraph>
                    Last updated: March 12, 2025
                </Typography>
            </StyledPaper>
        </Container>
    );
}

export default FAQ;
